import React from 'react'
import Skeleton from 'react-loading-skeleton';

function BlogPostArticleSkeleton() {
    return (
        <div className="col-lg-4 col-md-6 mt-md-5 mt-4">
            <div className="card">
                <div className="card-header p-0 position-relative">
                    <a href={`/posts/`}>
                        <Skeleton style={{ height: `15em` }} className="card-img-bottom d-block radius-image-full" />
                    </a>
                </div>
                <div className="card-body blog-details">
                    <a href={`/posts/`} className="blog-title"><Skeleton height={`2em`} /></a>
                    <br />
                    <br />
                    <Skeleton height={`1em`} />
                    <Skeleton height={`1em`} />
                    <Skeleton width={`5em`} />
                    <div className="author align-items-center mt-3 mb-1">
                        <Skeleton width={`2.5em`} height={`2.5em`} />
                        <ul className="blog-meta">
                            <li>
                                <a href={`/`}><Skeleton width={`2em`} /></a>
                            </li>
                            <li className="meta-item blog-lesson">
                                <span className="meta-value"> <Skeleton width={`2em`} /> </span>. <span className="meta-value ml-2"><span className="fa fa-clock-o" /> <Skeleton width={`2em`} /> min</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BlogPostArticleSkeleton
